import { MdSearch } from 'react-icons/md';
import { Link } from 'react-router-dom';

/**
 * Empty state when no results (or no results in visible map area).
 * variant 'noResultsInArea': pink/lavender card with CTA (like design)
 */
export default function ResultsListEmpty({
  inBounds = false,
  variant = 'default',
  isParent = true,
  onClear,
}) {
  if (variant === 'noResultsInArea') {
    return (
      <div
        className="flex flex-col items-center justify-center py-10 px-6 rounded-2xl min-h-[280px]"
        style={{ backgroundColor: '#FCE8EE' }}
        role="status"
        aria-label="Nema rezultata u oblasti"
      >
        <h3 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-gray-900 text-center mb-2">
          {isParent
            ? 'Nema odgovarajuće bebisiterke u vašem komšiluku?'
            : 'Nema poslova u ovoj oblasti?'}
        </h3>
        <p className="text-sm sm:text-base text-gray-600 dark:text-gray-700 text-center max-w-md mb-6">
          {isParent
            ? 'Dodajte svoj profil danas i mi ćemo se potruditi da pronađemo pouzdane bebisiterke u vašem kraju.'
            : 'Promenite lokaciju ili probajte pretragu u blizini da pronađete poslove u krugu od 2 km.'}
        </p>
        {isParent ? (
          <Link
            to="/register"
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-xl font-semibold text-white text-base transition-colors hover:opacity-95 focus:ring-2 focus:ring-offset-2 focus:ring-teal-600"
            style={{ backgroundColor: '#4A8F9F' }}
          >
            Započni
          </Link>
        ) : (
          <button
            type="button"
            onClick={onClear}
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-xl font-semibold text-white text-base transition-colors hover:opacity-95 focus:ring-2 focus:ring-offset-2 focus:ring-teal-600"
            style={{ backgroundColor: '#4A8F9F' }}
          >
            Promeni lokaciju
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-center justify-center py-12 px-6 min-h-[280px] rounded-2xl border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50"
      role="status"
      aria-label="Nema rezultata"
    >
      <div className="w-16 h-16 rounded-2xl bg-gray-200 dark:bg-gray-700 flex items-center justify-center mb-4">
        <MdSearch className="text-3xl text-gray-400 dark:text-gray-500" aria-hidden />
      </div>
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-1 text-center">
        {inBounds ? 'Nema rezultata u vidljivoj oblasti' : 'Nema rezultata za izabranu lokaciju'}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-xs">
        {inBounds
          ? 'Pomerite ili zumirajte mapu da vidite druge rezultate.'
          : 'Probajte drugu opštinu ili „Pretraži u blizini” za rezultate u krugu 2 km.'}
      </p>
    </div>
  );
}
